import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  grid: { spacing, resolution },
  primaryColours,
  borderRadius,
} = theme

export const ExistingMemberModalStyles = styled.div<{ focused: boolean }>`
  .heading {
    margin: ${spacing.md}px 0 ${spacing.base}px;
  }
  .overlay-text {
    color: ${primaryColours.aubergine.main};
  }
  .text-primary {
    margin-bottom: ${spacing.base}px;
  }
  .button-link {
    background: none;
    border: none;
    padding: 0;
    outline: inherit;
  }
  .button-link-text {
    ${({ focused }) =>
      focused &&
      `
        outline-offset: 4px;
        outline: 3px solid #240232;
        border-radius: ${borderRadius.double};
      `}
  }
  .link {
    text-decoration: underline;
    color: ${primaryColours.cyan.superDarkCyan};
    font-weight: 700;
    cursor: pointer;
  }
  .link-focused {
    &:focus {
      outline-offset: 4px;
      outline: 3px solid #240232;
      border-radius: ${borderRadius.double};
    }
  }
  .overlay-button {
    margin: ${spacing.base}px 0;
  }
  .message-text {
    margin-top: ${spacing.base}px;
    color: ${primaryColours.aubergine.main};
  }

  @media (min-width: ${resolution.tablet.width}px) {
    .heading {
      margin-bottom: ${spacing.md}px;
    }
    .overlay-button {
      margin: ${spacing.md}px 0;
    }
  }
`
